import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Header } from "react-frontier";
import { CDN_URL, PAGE } from "../ConfigPublic";
import { useUser } from "../HooksPublic";

var LoginResponse=()=>{
   var {logout, setUser, setToken}=useUser();
   var navigate=useNavigate();
   var [query]=useSearchParams();
   var [loginError, setLoginError]=useState<string>(null);
   
   useEffect(()=>{
      var access_token=query.get('at');
      var redirect=query.get('r');
      var expires=query.get('e');
      var user_string=query.get('user');
      var now = moment().unix();
      if(!access_token) return setLoginError('Token de acceso no proporcionado');

      var exp = expires ? parseInt(expires, 10) : 0;
      var expiresNum: number;
      if (exp > 1000000000000) {
         expiresNum = Math.floor(exp / 1000);
      } else if (exp > 100000000) {
         expiresNum = exp;
      } else if (exp > 0) {
         expiresNum = now + exp;
      } else {
         expiresNum = now + 86400;
      }

      if (expiresNum <= (now + 15)) return setLoginError('La autenticación ha expirado');
      var is_local_route=false;
      if(redirect && redirect.startsWith(window.location.origin)){
         is_local_route=true;
         redirect=redirect.substring(window.location.origin.length);
      }

      var handleSuccess = (user: any) => {
         localStorage.setItem('user_data', JSON.stringify({
            email: user.email,
            superadmin: user.superadmin,
            user_id: user.user_id,
            first_name: user.first_name,
            last_name: user.last_name,
            phone: user.phone,
            name: user.name || `${(user.first_name || '').trim()} ${(user.last_name || '').trim()}`.trim(),
            change_password: !!user.change_password,
            birthday: user.birthday,
            gender_id: user.gender_id,
            email_confirmed: user.email_confirmed,
         }));
         setUser({
            email: user.email,
            superadmin: user.superadmin,
            user_id: user.user_id,
            first_name: user.first_name,
            last_name: user.last_name,
            phone: user.phone,
            name: user.name || `${(user.first_name || '').trim()} ${(user.last_name || '').trim()}`.trim(),
            change_password: !!user.change_password,
            birthday: user.birthday,
            gender_id: user.gender_id,
            email_confirmed: user.email_confirmed,
         })
         localStorage.setItem('access_token', JSON.stringify({
            access: access_token,
            expires: expiresNum
         }))
         setToken({
            access: access_token,
            expires: expiresNum
         })
         if(redirect){
            if(is_local_route && navigate){
               navigate(redirect);
            }else{
               window.location.href=redirect;
            }
         }else{
            if(navigate){
               navigate('/');
            }else{
               window.location.href=PAGE;
            }
         }
      };

      if(user_string){
         try{
            var user=JSON.parse(decodeURIComponent(user_string));
            handleSuccess(user);
         }catch(err){
            setLoginError('Error procesando datos de usuario');
         }
      }else{
         setLoginError('No se recibió la información del usuario');
      }
   },[query, navigate, setUser, setToken]);


	if(loginError){
		return <div style={{ marginTop: 20 }}>
			<Header text='Error' size='big' centered subtext={`Hubo un error inesperado haciendo login: ${loginError}`} style={{ maxWidth: 500, margin: 'auto' }} />
			<div className="fr black basic button" style={{ margin: 'auto', display: 'block', width: 150, marginTop: 20 }} onClick={() => {
				logout();
				navigate('/');
			}}>
				Cerrar sesión
			</div>
		</div>
	}
	
	return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: '#f0f0f0' }}>
		<img src={`${CDN_URL}/logo/Logo_Small.webp`} alt="AREMA" style={{ borderRadius: 4, width: 100, height: 100, objectFit: 'contain' }} />
	</div>
}

export default LoginResponse;